export enum ColorsEnum {
  AQUAMARINE_DARK = '#0E8474',
  AQUAMARINE_LIGHT = '#DBFFEA',
  BLACK = '#161617',
  CORAL = '#F8733D',
  CORAL_DARK = '#CA3F13',
  CORAL_LIGHT = '#FFDECC',
  DEEP_PINK_DARK = '#C01371',
  DEEP_PINK_LIGHT = '#FFD7E9',
  GOLD_DARK = '#B85901',
  GOLD_LIGHT_100 = '#FFF5D8',
  GOLD_LIGHT_200 = '#FBDBAC',
  GREY_DARK = '#696A6F',
  GREY_MEDIUM = '#CBCDD2',
  LILAC_DARK = '#8337E9',
  LILAC_LIGHT = '#EAE3FF',
  PRIMARY = '#eb0055',
  PRIMARY_DARK = '#c10046',
  SECONDARY_DARK = '#25026C',
  SKY_BLUE = '#20C5E9',
  SKY_BLUE_DARK = '#0E78B7',
  SKY_BLUE_LIGHT = '#D6F8FF',
  WHITE = '#ffffff',
}

export const ACTIVE_OPACITY = 0.7
